import { Row, Colors, Utils } from '@microfrontends/react-components'
import styled from 'styled-components'

export const CareerPathByIndustryContainer = styled(Row)``

export const CareerChildWrapper = styled.a`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	& > .name {
		font-family: 'Dela Gothic One';
		font-size: 10px;
		color: ${Colors.darkBlue};
		text-transform: uppercase;
	}
`

export const CareerIconWrapper = styled.div`
	flex-shrink: 0;
	background-color: #fff;
	width: 100px;
	height: 100px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
`

export const ContentContainer = styled.div`
	overflow-x: hidden;
	max-height: 510px;
	@media (max-width: ${Utils.screens.mobile}px) {
		max-height: unset;
	}
`

export const ContentWrapper = styled(Row)`
	padding: 12px;
`
